function findQuestion(questions: any[], id: string): any {
    return questions.filter((x: any) => x.id === id)[0];
}
export default findQuestion;
